import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router } from "react-router-dom";
import { Switch } from "react-router-dom";

import Dashboard from "./main/dashboard/Index";



import Users from "./user-management/manageUser/user";
import SuperUsers from "./user-management/SuperUsers";



import FdwEmployerForm from "./employers/CollectEmployerInfo";

import ForgotPassword from "./authentication/forgot-password";
import PasswordReset from "./authentication/PasswordReset";
import LockScreen from "./authentication/lock-screen";

import ExternalForms from "./booking/ExternalForms";

import Profile from "./pages/profile/Index";
import Page404 from "./pages/errorpages/404";
import Page500 from "./pages/errorpages/500";
import BlankPage from "./pages/blank-page";

import SuperBiodata from "./biodata/SuperBiodata";


import ProfilebiodataEmployer from "./biodata/ProfilebiodataEmployer";

import { useLocation } from "react-router-dom/cjs/react-router-dom.min";



import BiodataForm from "./biodata/BiodataForm";
import AllBiodata from "./biodata/Allbiodata";

import ExtractBiodata from "./biodata/ExtractBiodata";

import PrivateRoute from "./PrivateRoute";
import Profilebiodata from "./biodata/Profilebiodata";

import Login from "./authentication/Login";

import RegisterSupplierAdmin from "./authentication/RegisterSupplierAdmin";
import RegisterSupplierStaff from "./authentication/RegisterSupplierStaff";
import VerificationNotifications from "./authentication/VerificationNotifications";
import VerificationAdmin from "./authentication/VerificationAdmin";

import RegisterAgencyAdmin from "./authentication/RegisterAgencyAdmin";
import RegisterAgencyStaff from "./authentication/RegisterAgencyStaff";

import AgenciesDirectory from "./vendor/AgencyList";
import VendorDirectory from "./agency/VendorList";
import CompanyDetails from "./layouts/CompanyDetails";

import UserDetails from "./layouts/UserDetails";



import Invitations from "./user-management/Invitations"








import AgenciesInvitations from "./vendor/AgenciesInvitations";
import VendorInvitations from "./agency/VendorInvitations";
import InvitePending from "./layouts/InvitePending";

import Booking from "./booking/Booking";
import Onhold from "./booking/Onhold";

import EmployerManagement from "./agency/EmployerManagement";
import EmployerBiodataShared from "./employers/EmployerBiodataShared";
import EmployerLinkList from "./agency/EmployerLinkList";
import EmployerDetails from "./employers/EmployerDetails";

import Documentation from "./support/Documentation";
import Feedback from "./support/Feedback";
import SuperDeletedBiodata from "./biodata/SuperDeletedBiodata";




const AppContainer = () => {
  // const config = "/template/react";
  const [showStickySidebar, setShowStickySidebar] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Hide the sidebar on the "/invoices" page
    setShowStickySidebar(
      location.pathname !== "/invoice-one-a" &&
        location.pathname !== "/invoice-two" &&
        location.pathname !== "/invoice-three" &&
        location.pathname !== "/invoice-four-a" &&
        location.pathname !== "/invoice-five" &&
        location.pathname !== "/cashreceipt-1" &&
        location.pathname !== "/cashreceipt-2" &&
        location.pathname !== "/cashreceipt-3" &&
        location.pathname !== "/cashreceipt-4"
    );
  }, [location.pathname]);

  return (

    <Router basename="/">
    
      <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/verification-notifications" exact component={VerificationNotifications} />
        
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={PasswordReset} />
        <Route path="/lock-screen" component={LockScreen} />
        <Route path="/error-404" component={Page404} />
        <Route path="/error-500" component={Page500} />
        <Route path="/blank-page" component={BlankPage} />

        <Route path="/register-agencystaff" component={RegisterAgencyStaff} />
        <Route path="/register-agency" component={RegisterAgencyAdmin} />

        <Route path="/register-vendor" component={RegisterSupplierAdmin} />
        <Route path="/register-vendorstaff" component={RegisterSupplierStaff} />
        <Route path="/account-confirmation" component={VerificationAdmin} />
        

        <PrivateRoute path="/"  exact component={AllBiodata} />
        <PrivateRoute path="/index"  exact component={AllBiodata} />
        <PrivateRoute path="/dashboard"  exact component={AllBiodata} />
        <PrivateRoute path="/biodata-form" component={BiodataForm} />
        <PrivateRoute path="/biodata-form-extract" component={ExtractBiodata} />
        <PrivateRoute path="/allbiodata" component={AllBiodata} />
        <PrivateRoute path="/agency-biodata" component={AllBiodata} />
        <PrivateRoute path="/vendor-agency-biodata" component={AllBiodata} />
        <PrivateRoute path="/super-biodata" component={SuperBiodata} />
        <PrivateRoute path="/super-deleted-biodata" component={SuperDeletedBiodata} />
        <PrivateRoute path="/super-users" component={SuperUsers} />


  



        
        <PrivateRoute path="/biodata/:id" component={Profilebiodata} />

        <PrivateRoute path="/invite/pending" component={InvitePending} />
        

        <PrivateRoute path="/agency-list" component={AgenciesDirectory} />
        <PrivateRoute path="/vendor-list" component={VendorDirectory} />
        <PrivateRoute path="/agencies-invitations" component={AgenciesInvitations} />
        <PrivateRoute path="/vendor-invitations" component={VendorInvitations} />

        <PrivateRoute path="/employer-management" component={EmployerManagement} />
        <PrivateRoute path="/employer/:id/links" component={EmployerLinkList} />
        <PrivateRoute path="/employer/:id/profile" component={EmployerDetails} />

        <PrivateRoute path="/vendor-details" component={CompanyDetails} />
        <PrivateRoute path="/agency-details" component={CompanyDetails} />

        <PrivateRoute path="/profile/:id" component={UserDetails} />
        
        <PrivateRoute path="/staff" component={Users} />
        <PrivateRoute path="/invitations" component={Invitations} />
       
        <Route path="/employer-biodata-shared" component={EmployerBiodataShared} />

        {/*<PrivateRoute path="/add-user" component={AddUser} />
        <PrivateRoute path="/users" component={Users} />
        <PrivateRoute path="/edit-users" component={EditUser} />
*/}
 

        <PrivateRoute path="/booking" exact component={Booking} />
        <PrivateRoute path="/booking/external-forms/:id/:booking_id" component={ExternalForms} />
        <PrivateRoute path="/booking/onhold"  component={Onhold} />


        <Route path="/biodata-employer/:id" component={ProfilebiodataEmployer} />
        <Route path="/documentation" component={Documentation} />
        <Route path="/feedback" component={Feedback} />
        <Route path="/employer-form" component={FdwEmployerForm} />
     
        <Route component={Page404} />

       
        
        

      </Switch>
    </Router>
   
  );
};

export default AppContainer;
